<script>
export default {
  props: {
    /** Width sizing approach. */
    width: {
      type: [String, Number],
      default: '1.5em',
    },
    /** Height sizing approach. */
    height: {
      type: [String, Number],
      default: '1.5em',
    },
    /** For accessibility. Not visible. To communicate what this icon represents to screen readers. */
    title: {
      type: String,
      default: 'Loading',
    },
  },
}
</script>
<template>
  <svg
    data-testid="loading-spinner"
    role="status"
    :aria-label="title"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    class="text-science-blue-100 motion-safe:animate-spin"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>

    <path
      d="M20.4853 20.4853C18.8071 22.1635 16.6689 23.3064 14.3411 23.7694C12.0133 24.2324 9.60051 23.9948 7.4078 23.0866C5.21509 22.1783 3.34094 20.6402 2.02236 18.6668C0.703788 16.6935 1.46173e-07 14.3734 0 12C-1.46173e-07 9.62663 0.703787 7.30655 2.02236 5.33316C3.34094 3.35977 5.21508 1.8217 7.4078 0.913446C9.60051 0.00519429 12.0133 -0.232446 14.3411 0.230576C16.6689 0.693599 18.8071 1.83649 20.4853 3.51472L17.0912 6.90883C16.0842 5.90189 14.8013 5.21616 13.4046 4.93835C12.008 4.66053 10.5603 4.80312 9.24468 5.34807C7.92905 5.89302 6.80456 6.81586 6.01342 7.99989C5.22227 9.18393 4.8 10.576 4.8 12C4.8 13.424 5.22227 14.8161 6.01342 16.0001C6.80456 17.1841 7.92905 18.107 9.24468 18.6519C10.5603 19.1969 12.008 19.3395 13.4047 19.0617C14.8013 18.7838 16.0842 18.0981 17.0912 17.0912L20.4853 20.4853Z"
      fill="currentColor"
    />
  </svg>
</template>
